import React, { useEffect, useState } from 'react'
import DashboardRoute from './DashboardRoute'
import Trips from 'app/components/trips/TripsPage'
import Vehicles from 'app/components/vehicles/VehiclesPage'
import DriversPage from 'app/components/drivers/DriversPage'
import * as selectors from 'app/selectors'
import { useSelector } from 'react-redux'
import Client from 'mz-sdk/client'
import { REFRESH_TOKEN_ENDPOINT } from 'app/constants/endpoints'

export const useToken = () => localStorage.getItem('mozio-auth-token')

const ProvidersV2 = () => {
  const [token, setToken] = useState(null)

  // TEMPORARY: Refresh token solution
  useEffect(() => {
    ;(async () => {
      const response = await Client.post(REFRESH_TOKEN_ENDPOINT, {
        body: {
          refresh_token: localStorage.getItem('mozio-refresh-token'),
        },
      })
      setToken(response.token)
    })()
  }, [])

  if (!token) {
    return <div>Loading...</div>
  }

  const baseUrl =
    process.env.CONFIG_ENV === 'production'
      ? 'https://providers-v2.mozio.com/providers-dashboard/reports'
      : 'https://providers-v2-staging.mozio.com/providers-dashboard/reports'
  const url = `${baseUrl}?token=${token}`

  return (
    <iframe src={url} width="100%" height="100%" style={{ border: 'none' }} />
  )
}

const Iframe = ({ baseUrl }) => {
  const token = useToken()
  const { providerId, providerEmail, providerUid, providerName } = useSelector(
    selectors.getProviderInformation
  )
  const queryParams = {
    token,
    provider_id: providerId,
    provider_email: providerEmail,
    provider_uid: providerUid,
    provider_name: providerName,
    ph_enabled: localStorage.getItem('ph_enabled'),
  }
  const queryString = Object.entries(queryParams)
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
    )
    .join('&')
  const url = `${baseUrl}?${queryString}`

  return (
    <iframe
      src={url}
      width="100%"
      height="100%"
      style={{ border: 'none', overflow: 'hidden' }}
    />
  )
}

const PricingV2 = () => {
  const baseUrl =
    process.env.CONFIG_ENV === 'production'
      ? 'https://providers-v2.mozio.com/providers-dashboard/pricing/price-updates'
      : 'https://providers-v2-staging.mozio.com/providers-dashboard/pricing/price-updates'
  return <Iframe baseUrl={baseUrl} />
}

const AdvancedPricingV2 = () => {
  const baseUrl =
    process.env.CONFIG_ENV === 'production'
      ? 'https://providers-v2.mozio.com/providers-dashboard/pricing/advanced-pricing'
      : 'https://providers-v2-staging.mozio.com/providers-dashboard/pricing/advanced-pricing'
  return <Iframe baseUrl={baseUrl} />
}

const BlockedDatesV2 = () => {
  const baseUrl =
    process.env.CONFIG_ENV === 'production'
      ? 'https://providers-v2.mozio.com/providers-dashboard/blocked-dates'
      : 'https://providers-v2-staging.mozio.com/providers-dashboard/pricing/blocked-dates'
  return <Iframe baseUrl={baseUrl} />
}

export const routes = [
  {
    path: '/trips/:hash?',
    pathTo: '/trips',
    name: 'Trips',
    icon: 'swap_calls',
    component: Trips,
  },
  {
    path: '/drivers',
    pathTo: '/drivers',
    name: 'Drivers',
    icon: 'group',
    component: DriversPage,
  },
  {
    path: '/vehicles',
    pathTo: '/vehicles',
    name: 'Vehicles',
    icon: 'directions_car',
    component: Vehicles,
  },
  {
    path: '/pricing',
    pathTo: '/pricing',
    name: 'Pricing',
    icon: 'local_offer',
    badge: 'New',
    component: PricingV2,
    subRoutes: [
      {
        path: '/pricing',
        pathTo: '/pricing',
        name: 'Price updates',
        component: PricingV2,
      },
      {
        path: '/advanced-pricing',
        pathTo: '/advanced-pricing',
        name: 'Advanced pricing',
        badge: 'New',
        component: AdvancedPricingV2,
      },
      {
        path: '/blocked-dates',
        pathTo: '/blocked-dates',
        name: 'Blocked dates',
        badge: 'New',
        component: BlockedDatesV2,
      },
    ],
  },
  {
    path: '/reports',
    pathTo: '/reports',
    name: 'Reports',
    icon: 'pie_chart',
    badge: 'New',
    component: ProvidersV2,
  },
]

const DashboardRoutes = () => {
  const routeMap = new Map()

  routes.forEach((route) => {
    routeMap.set(route.path, route)
  })

  const subRoutes = routes
    .filter((route) => route.subRoutes)
    .flatMap((route) => route.subRoutes)

  subRoutes.forEach((subRoute) => {
    routeMap.set(subRoute.path, subRoute)
  })

  const uniqueRoutes = Array.from(routeMap.values())

  return (
    <>
      {uniqueRoutes.map((route, index) => (
        <DashboardRoute key={`route-${route.path}-${index}`} exact {...route} />
      ))}
    </>
  )
}

export default DashboardRoutes
